<template>
  <QS-common-table
    :columns="columns"
    :data="tableData"
    :pagination="false"
    row-key="receivableId"
  >
  </QS-common-table>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  name: 'CollectionRecordDetailsTable',
  data() {
    return {
      columns: [
        {
          name: 'receiptId',
          columnProps: {
            label: '收款单ID',
            prop: 'receiptId',
          },
          render: ({ row }) => <span>{row.receiptId}</span>,
        },
        {
          name: 'receivableId',
          columnProps: {
            label: '应收ID',
            prop: 'receivableId',
          },
          render: ({ row }) => <span>{row.receivableId}</span>,
        },
        {
          name: 'content',
          columnProps: {
            label: '收款内容',
            prop: 'content',
          },
          render: ({ row }) => <span>{this.freeTypeList[row.content]}</span>,
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
          render: ({ row }) => <span>{row.plateNo}</span>,
        },
        {
          name: 'sourceOrderType',
          columnProps: {
            label: '来源单类型',
            prop: 'sourceOrderType',
            minWidth: '130',
          },

          render: ({ row }) => (
            <span>{selectOption.sourceOrderTypeDict[row.sourceOrderType]}</span>
          ),
        },
        {
          name: 'sourceOrderId',
          columnProps: {
            label: '来源单ID',
            prop: 'sourceOrderId',
          },
          render: ({ row }) => <span>{row.sourceOrderId}</span>,
        },
        {
          name: 'receivableDate',
          columnProps: {
            label: '应收日期',
            prop: 'receivableDate',
            width: 100,
          },
          render: ({ row }) => <span>{row.receivableDate}</span>,
          type: 'date',
        },
        {
          name: 'state',
          columnProps: {
            label: '收款单状态',
            prop: 'state',
            minWidth: '100',
          },

          render: ({ row }) => <span>{row.state}</span>,
        },
        {
          name: 'amount',
          columnProps: {
            label: '本次收款金额（元）',
            prop: 'amount',
            minWidth: '150',
          },
          render: ({ row }) => <span>{row.amount}</span>,
        },
      ],
    }
  },

  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    freeTypeList: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
.add-table ::v-deep .el-form-item {
  margin-top: 20px;
  margin-bottom: 20px;
}
.add-table ::v-deep td {
  padding: 0 !important;
}
.add-table {
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
#app .add-table ::v-deep thead tr th {
  border: none !important;
}
.delete-order {
  &-btns {
    text-align: right;
    margin: 0;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px !important;
    .cancel-btn {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      border: 1px solid #dcdee0;
      font-family: PingFangSC-Regular;
      color: #323233;
      border-radius: 3px;
      font-size: 12px;
    }
  }
}
</style>
